import type { ExtractPropTypes } from 'vue';
import type ImageVerification from './image-verification.vue';

export const ImageVerificationProps = {
  modelValue: {
    type: String,
    default: '',
  },
};

export type ImageVerificationPropsType = ExtractPropTypes<typeof ImageVerificationProps>;
export type ImageVerificationInstance = InstanceType<typeof ImageVerification>;
